import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
    const formRef = useRef();

    const handleSubmit = e => {
        e.preventDefault();
        emailjs.sendForm('service_soiofy1', 'template_10fx4fy', formRef.current, 'EdWXe7eq_REBo0bNa')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
    };
    

    return (
        <div className='c mt-14'>
            <h1 className='bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500 text-5xl font-bold'>Contact Me</h1>

            <div className='c-bg'>
                <div className="c-wrapper grid lg:grid-cols-2 mt-12">
                    <div className="c-left flex-1">
                        <h1 className="text-3xl font-bold mb-4">
                            Let's Talk About My Project 
                        </h1>
                        <p className='text-2xl text-red-300'>Name: Sarfaraj Shaikat</p>
                        <p className='text-2xl text-red-300'>Email: sarfarajshaikat@gmail.com</p>
                        <p className='text-2xl text-red-300'>Phone: +8801750822264</p>
                    </div>
                    <div className="c-right flex-1">
                        <p className="text-3xl font-bold mb-9">
                            Get in touch. Always freelancing if the right project comes alone.
                        </p>

                        <form ref={formRef} onSubmit={handleSubmit}>
                            <input type="text" placeholder="Your Name" name='user_name' class="input input-bordered input-primary w-full max-w-xs my-3" /> <br />
                            <input type="text" placeholder="Subject" name='user_subject' class="input input-bordered input-primary w-full max-w-xs" /> <br />
                            <input type="text" placeholder="Email" name='user_email' class="input input-bordered input-primary w-full max-w-xs my-3" /> <br />
                            <textarea rows='5' class="textarea textarea-accent w-1/2 my-3" placeholder="Message" name='message'></textarea> <br />

                            {/* <button value='Send' type="button" className=" btn bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none">Send Maill
                        </button> */}
                        <button className="btn bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none"><input type="submit" value="Send Me Mail" /></button>
                        


                        </form>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default Contact;